import { RoleAccess } from "../../hooks/auth/types";
import { Role } from "../../models";
import {
  CommitteeDecision,
  CommitteeEnrollmentDecision,
  RequestStatus,
  RequestType,
  Request,
} from "../../models/Request";

export const REQUEST_DETAILS_ADMIN_ACCESS: RoleAccess = {
  whitelist: [Role.CAS, Role.Helpdesk],
};

export const REQUEST_DETAILS_INSTITUTION_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.InstitutionAdministrator,
    Role.InstitutionPrincipal,
  ],
};

export const REQUEST_DETAILS_COUNTY_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
  ],
};

export const PROCEDURE_SUBMITTED_STATUSES = [
  RequestStatus.ProcedureSubmitted,
  RequestStatus.OnSchoolCandidateList,
  RequestStatus.Cancelled,
];

export const ENROLLMENT_INSTITUTION_STATUSES = [
  RequestStatus.EnrollmentConfirmed,
  RequestStatus.RegistrationFormCreating,
  RequestStatus.RegistrationFormCreated,
  RequestStatus.Registered,
];

export const RETURN_TO_SUBMITTED_STATUSES = [
  RequestStatus.ProcedureSubmitted,
  RequestStatus.Submitted,
  RequestStatus.Draft,
  RequestStatus.RegistrationFormCreating,
];

export const RETURN_TO_PROCEDURE_STATUSES = [
  RequestStatus.Cancelled,
  RequestStatus.ProcedureApproved,
  RequestStatus.ProcedureRejected,
  RequestStatus.OnSchoolCandidateList,
];

export const DEFAULT_COMMITTEE_DECISION: CommitteeDecision = {
  id: 0,
  requestId: 0,
  committeeEmployeeId: 0,
  committeeEnrollmentDecisionId: CommitteeEnrollmentDecision.Ready,
  updatedDate: new Date(),
  dateCreated: new Date(),
  hasDecisionsInPreviousInstitutionCommittees: null,
  hasDecisionsInPreviousCountyCommittees: null,
};

export const DEFAULT_REQUEST: Request = {
  id: 0,
  requestUID: "",
  code: "",
  statusId: RequestStatus.Draft,
  schoolYearId: 0,
  type: RequestType.RegularEnrollment,
  createdByAdmin: true,
  isOutsideEnrollmentArea: false,
  step: 0,
  subStep: 0,
  parentRemark: null,
};
